import React from 'react';
import './SuggestedQueries.css';

const DEFAULT_QUERIES = [
  "Today's OEE",
  "Open work orders",
  "Downtime this week",
  "Overdue PM tasks",
  "Safety summary",
  "Machine health overview"
];

const SuggestedQueries = ({ queries = DEFAULT_QUERIES, onSelect }) => {
  if (!queries || queries.length === 0) return null;

  return (
    <div className="suggested-queries custom-scrollbar">
      {queries.map((query, index) => (
        <button 
          key={index} 
          className="query-chip" 
          onClick={() => onSelect(query)}
        >
          {query}
        </button>
      ))}
    </div>
  );
};

export default SuggestedQueries;
